import React, { useEffect, useState } from 'react';
import { Checkbox, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const CheckboxInput = ({
  placeholder,
  children,
  onChange,
  value,
  id,
  hint
}) => {
  const [loaded, setLoaded] = useState(false);
  const [visible, setVisible] = useState(!!value);

  useEffect(() => {
    if (!loaded && value) {
      setLoaded(true);
      setVisible(true);
    }
  }, [value]);

  const handleChange = ({ target }) => {
    if (!target.checked) {
      onChange(null);
    }

    setVisible(target.checked);
  };

  return (
    <div>
      <Checkbox
        onChange={handleChange}
        checked={visible}
        className={visible ? 'gx-mb-2' : ''}
      >
        {placeholder}
        {hint ? (
          <Tooltip title={hint}>
            <InfoCircleOutlined className="gx-ml-1 gx-fs-sm" />
          </Tooltip>
        ) : null}
      </Checkbox>
      {visible
        ? React.cloneElement(children, {
            value,
            id,
            onChange
          })
        : null}
    </div>
  );
};

export default CheckboxInput;
